import { computed, ref, onMounted } from "vue"
import debounce from "../../foundation/js/debounce"
import ChatSendButton from "../ChatPanel/ChatSendButton/ChatSendButton";
import { useViewport } from "../../composables/use-viewport.composable";

export default {
  name: "SearchInputField",
  components: {
    ChatSendButton
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'search'
    },
    hint: {
      type: String,
      required: false,
    },
    searchIconLabel: {
      type: String,
      required: false,
    },
    closeIconLabel: {
      type: String,
      required: false,
    },
    legend: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    searchInputAriaLabel: {
      type: String,
      required: false,
    },
    initSearchParam: {
      type: String,
      required: false,
    },
    onChangeCallback: {
      type: Function,
      required: false,
    },
    onEnterCallback: {
      type: Function,
      required: false,
    },
    redirectUrl: {
      type: String,
      required: false,
    },
    searchButtonAriaLabel: {
      type: String,
      required: false,
    },
    searchResetAriaLabel: {
      type: String,
      required: false,
    },
    maxLength: {
      type: Number,
      default: 300,
    },
    compact: {
      type: Boolean,
      default: true,
    }
  },
  setup(props) {
    const isCompact = ref(props.compact)
    const searchInputModel = ref(props.type === 'ai-assistant' ? "" : props.initSearchParam || "");
    const searchInput = ref("")
    const searchTextArea = ref("")
    const { viewport } = useViewport();

    onMounted(() => {
      if (!isCompact.value && (viewport.value === 'large' || viewport.value === 'xLarge')) {
        searchTextArea.value.focus()
      }
    });

    const inputUpdated = debounce(() => {
      if (props.onChangeCallback && searchInputModel.value !== "") {
        props.onChangeCallback(searchInputModel.value)
      }
    }, 500)

    const inputIsNotEmpty = computed(() => {
      return searchInputModel.value !== ""
    })

    const emptyInput = () => {
      searchInputModel.value = ""

      if (isCompact.value) {
        searchInput.value.focus()
      }
      else {
        searchTextArea.value.focus()
      }

      if (props.onChangeCallback) {
        props.onChangeCallback(searchInputModel.value)
      }
    }

    const onSearchEnter = (event) => {
      if (event) {
        event.preventDefault();
      }
      isCompact.value = props.type === 'ai-assistant' ? false : props.compact;
      if (props.redirectUrl) {
        window.location.href = `${props.redirectUrl}?q=${searchInputModel.value}`
      } else if (props.onEnterCallback) {
        props.onEnterCallback(searchInputModel.value)
      }

      if (props.type === 'ai-assistant') {
        searchInputModel.value = '';

        if (viewport.value !== 'large' && viewport.value !== 'xLarge') {
          searchTextArea.value.blur();
        }
      }
    }

    return {
      searchInputModel,
      searchInput,
      searchTextArea,
      isCompact,
      emptyInput,
      onSearchEnter,
      inputIsNotEmpty,
      inputUpdated,
    }
  },
}